/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect } from "react";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";


const CustomerDocumentIdentity = (props) => {
  useEffect(() => {
    console.log(props.contentModal);
  }, []);

  console.log(props.contentModal.Identity);

  return (
		<Dialog open={true} maxWidth={"lg"}> 
			<ModalStyle property={String(false)}>				
				<DialogTitle >
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<DialogContent >
				{props.contentModal.Identity !== "Pasaporte" &&
					<Grid container spacing={2} sx={{ marginTop: "10px" }}>
						{props.contentModal.self && 
							<Grid item xs={2}>
								<img src={props.contentModal.self} />
							</Grid>						
						}
						{props.contentModal.front && 
							<Grid item xs={5}>
								<img src={props.contentModal.front} />
							</Grid>						
						}
						{props.contentModal.back && 
							<Grid item xs={5}>
								<img src={props.contentModal.back} />
							</Grid>						
						}						
					</Grid>}

					{props.contentModal.Identity === "Pasaporte" &&
					<Grid container spacing={2} sx={{ marginTop: "10px" }}>
						{props.contentModal.self && 
							<Grid item xs={5}>
								<img src={props.contentModal.self} />
							</Grid>						
						}
						{props.contentModal.front && 
							<Grid item xs={7}>
								<img src={props.contentModal.front} />
							</Grid>						
						}					
					</Grid>}
				</DialogContent>

				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cerrar</Button>     
				</DialogActions>
			</ModalStyle>
		</Dialog>					
  );
};

export default CustomerDocumentIdentity;
